import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
export const Fallback = ({ error }) => {
    return (
    // @TODO add some basic styling and a user friendly message
    _jsxs("details", { children: [error?.name, _jsx("br", {}), error?.message, _jsx("br", {}), error?.stack, _jsx("br", {})] }));
};
